import { useState } from "react";

import Image from "next/image";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import { useOrganizationConfig } from "shared/hooks/useOrganizationConfig";

import { BillboardBannerWithLinkContainer, FallbackBackground } from "./styles";

export const BillboardBannerWithLink = () => {
  const [imageFailedToLoad, setImageFailedToLoad] = useState(false);
  const { selectedOrganization } = useOrganizationConfig();

  return (
    <BillboardBannerWithLinkContainer
      hasLink={!!selectedOrganization?.billboard_link}
    >
      <a
        href={selectedOrganization?.billboard_link}
        target="_blank"
        rel="noreferrer"
      >
        <ComponentErrorBoundary>
          {imageFailedToLoad ? (
            <FallbackBackground>
              Não foi possível carregar a imagem =/
            </FallbackBackground>
          ) : (
            <Image
              alt=""
              src={selectedOrganization?.billboard_banner_address}
              fill
              quality={90}
              onError={() => setImageFailedToLoad(true)}
            />
          )}
        </ComponentErrorBoundary>
      </a>

      <div className="background-linear-gradient" />
    </BillboardBannerWithLinkContainer>
  );
};
